export default __webpack_public_path__ + "static/media/txt_entrance_04.6f3e6168.svg";